import React from 'react'
import styled from 'styled-components'
import { SIZES } from '../../constants'

const Wrapper = styled.a`
  width: 100%;
  position: relative;
  background-color: #F2F3F8;
  background-repeat: no-repeat;
  border-radius: 8px;
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  color: #000000;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 5px 16px 0;
  overflow: hidden;
  z-index: 2;
  display: block;

  &:before {
    content: "";
    position: absolute;
    top: -40px;
    right: -8px;
    width: 82px;
    height: 83px;
    display: block;
    background-image: url('${STATICS_PATH}images/plague/background.jpg');
    transform: scaleX(-1);
    background-position: 0 0;
    background-repeat: no-repeat;
  }

  &:hover {
    text-decoration: none;
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-top: 20px;
  }

  @media (max-width: ${SIZES.BREAKPOINT_SM - 1}px) {
    padding: 10px 16px 0;

    &:before {
      background-image: none;
    }
  }
`

const MainBoxItem = styled.div`
  margin-top: 10px;
  flex: 0 0 70%;
  margin-bottom: 16px;

  @media (max-width: ${SIZES.BREAKPOINT_SM - 1}px) {
    margin-top: 0;
    flex: 0 0 100%;
    padding-left: 0;
  }
`

const DataWrapper = styled.div`
  text-align: center;
  position: relative;
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  z-index: 1;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    justify-content: space-between;
  }
`

const DataItem = styled.div`
  display: block;
  flex-grow: 1;
  text-align: left;
  box-sizing: border-box;
  color: #000000;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    flex: 0 0 auto;
  }
`

const DataNewCases = styled.h3`
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  margin-bottom: 0;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 14px;
    line-height: 14px;
  }
`

const DataAllCases = styled.p`
  font-size: 13px;
  margin-bottom: 0;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 9px;
    line-height: 13px;
  }
`

const HospitalizedNumber = styled.span`
  color: #48A9A6;
`

const SickNumber = styled.span`
  color: #d31818;
`
const HealthyNumber = styled.span`
  color: #287e05;
`

const DataKey = styled.em`
  font-weight: normal;
  font-size: 13px;
  line-height: 24px;
  font-style: normal;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 10px;
    line-height: 10px;
  }
`

const partitionBySource = (items, source) => {
  const noMatch = []
  const match = []

  items.forEach(item => item.source === source ? match.push(item) : noMatch.push(item))

  return [ noMatch ]
}

const formatNumber = (number) => number.toLocaleString('en').replace(/,/g, ' ')

const formatNumberWithSign = (number) => {
  const formattedNumber = formatNumber(number)
  return (formattedNumber[0] === '-') ? formattedNumber : '+' + formattedNumber
}

export default (props) => {
  const {
    widget: {
      boxes
    }
  } = props
  const [ [ stats ] ] = partitionBySource(boxes, 'BbxCoronavirus')

  return (
    <Wrapper href="https://zpravy.aktualne.cz/widget-koronavirus-vse-o-koronaviru/r~28c952346d0611eaa6f6ac1f6b220ee8/" target="_blank">
      <MainBoxItem>
        <DataWrapper>
          <DataItem>
            <DataKey>Nakažených</DataKey>
            <SickNumber>
              <DataNewCases>{formatNumberWithSign(stats.diffSick)}</DataNewCases>
              <DataAllCases>{formatNumber(stats.countSick)}</DataAllCases>
            </SickNumber>
          </DataItem>
          <DataItem>
            <DataKey>Uzdravených</DataKey>
            <HealthyNumber>
              <DataNewCases>{formatNumberWithSign(stats.diffRecover)}</DataNewCases>
              <DataAllCases>{formatNumber(stats.countRecover)}</DataAllCases>
            </HealthyNumber>
          </DataItem>
          <DataItem>
            <DataKey>Hospitalizovaných</DataKey>
            <HospitalizedNumber>
              <DataNewCases>{formatNumberWithSign(stats.diffHospitalized)}</DataNewCases>
              <DataAllCases>{formatNumber(stats.countHospitalized)}</DataAllCases>
            </HospitalizedNumber>
          </DataItem>
          <DataItem>
            <DataKey>Úmrtí</DataKey>
            <DataNewCases>{formatNumberWithSign(stats.diffDead)}</DataNewCases>
            <DataAllCases>{formatNumber(stats.countDead)}</DataAllCases>
          </DataItem>
        </DataWrapper>
      </MainBoxItem>
    </Wrapper>
  )
}
